<div class="m-content slab-approval-container">
  <div class="row loginOuterBox">
      <div class="offset-md-3 col-md-6">

        <div class="container">
          <form class="auth-login-form mt-2">
            <div class="form-group">
              <label class="otp-enter-message">{{otpMessage}}</label>
              <input type="text" maxlength="6" name="otp" *ngIf="showOTPForm" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" placeholder="Enter OTP" class="form-control" [(ngModel)]="approvalOTP" aria-describedby="login-password" style="border-color: black;" />
            </div>
            <button class="btn btn-primary btn-block" *ngIf="showOTPForm" style="color: #000;" (click)="verifyOTP()" rippleEffect>Proceed</button>
            <br>
          </form>
        </div>

      </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/core/pages/admin/Master/b2c-rate-approval/consumer-slab-rate-approval.component.html